import React from "react";
import { LuSettings, LuUsers, LuSmartphone, LuShieldCheck, LuPercent, LuShield, LuPalette, LuCode, LuRocket, LuCircleCheck } from "react-icons/lu";
import { FiZap, FiUsers, FiMessageSquare, FiGlobe, FiTrendingUp, FiPieChart } from "react-icons/fi";

export const SocialAppHeroData = {
  backgroundImage: "/images/serviceBanners/socialMediamarketing.webp",
  whiteImage: "/images/serviceBanners/SocialBannerW.webp",
  subTitle: "Social Media Marketing Services",
  title: (
    <>
      Scale Your Brand with <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Smarter Social Media Marketing</span>
    </>
  ),
  description:
    "We deliver data driven social media marketing strategies that enhance engagement, improve audience targeting, and drive measurable business growth through performance focused campaigns, optimized content, and actionable insights.",
  primaryButton: {
    title: "Get a Social Audit",
    onClick: () => console.log("Social Audit clicked"),
  },
  secondaryButton: {
    title: "View Case Studies",
    onClick: () => console.log("Social Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Scroll-Stopping Content",
      desc: "High-quality content designed to capture attention and drive engagement.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Trend Intelligence",
      desc: "Identify emerging trends early to stay ahead of audience interest.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Influencer Collaboration",
      desc: "Creator partnerships aligned with your brand goals and audience.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Performance Tracking",
      desc: "Measure social engagement with clear, conversion-focused insights.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/reactjs.svg", // Generic modern tech icon
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(168,85,247,0.35)",
      iconGlow: "rgba(168,85,247,0.9)",
    },
  ],
};
// 2. Performance Stats Block
export const socialStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block
export const socialSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE SCALE",
  buildTitle: "Creative Strategies for High-Impact Social Growth",
  buildCards: [
    {
      title: "Content Acceleration",
      desc: "Scale high-performing content with trend-focused social strategies.",
      icon: FiZap,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Audience Targeting",
      desc: "Reach the right audience across key social platforms with precision.",
      icon: FiUsers,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Community Engagement",
      desc: "Build stronger connections through active audience interaction.",
      icon: FiMessageSquare,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Consistent Brand Presence",
      desc: "Maintain a clear and unified brand voice across all channels.",
      icon: FiGlobe,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Paid Campaign Optimization",
      desc: "Optimize social ads for better reach, engagement, and conversion performance.",
      icon: FiTrendingUp,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Analytics & Reporting",
      desc: "Track performance metrics to improve ongoing social strategy and execution results.",
      icon: FiPieChart,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR SOCIAL MEDIA GROWTH PROCESS",
  processTitle: "Our Social Media Growth Process",
  processSteps: [
    {
      step: "01",
      title: "Audit & Discovery",
      description: "Review current social performance and audience opportunities.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy Development",
      description: "Build content direction, brand voice, and campaign planning.",
      icon: LuPalette,
    },
    {
      step: "03",
      title: "Campaign Launch",
      description: "Execute data-driven social campaigns with performance tracking.",
      icon: LuCode,
    },
    {
      step: "04",
      title: "Growth & Optimization",
      description: "Scale winning strategies to improve engagement and results.",
      icon: LuRocket,
    },
    {
      step: "05",
      title: "Paid Campaign Management",
      description: "Run and optimize highly targeted ads for better target reach and conversions.",
      icon: LuCircleCheck, // Compile-safe fallback token to prevent Next.js bundle anomalies
    },
    {
      step: "06",
      title: "Performance Analytics",
      description: "Track deep user insights and platform metrics to improve future social strategies.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY BRANDS CHOOSE OUR SOCIAL MEDIA STRATEGY",
  benefitsTitle: "Social Trends & Performance Insights",
  benefits: [
    "Trend-based strategies to capture audience attention early",
    "Short-form video content designed for stronger engagement",
    "Creator and influencer partnerships aligned with brand goals",
    "Performance tracking focused on measurable business impact",
    "Consistent community engagement to strengthen brand trust",
  ],
  logoImage: "/images/serviceBanners/socialMediamarketing.webp",
  whiteLogoImage: "/images/serviceBanners/SocialBannerW.webp",
};
// 4. Portfolio / Results Block
export const socialPortfolioData = {
  subtitle: "OUR RESULTS",
  title: "Social Campaigns That Went Viral",
  buttonText: "View Case Studies",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Lifestyle App",
      badge: "Viral Campaign",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "Generating 10M+ impressions in 14 days using predictive trend modeling.",
      downloads: "10M+ Reach",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=2074&auto=format&fit=crop",
    },
    {
      title: "B2B Tech",
      badge: "Authority Sync",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Establishing LinkedIn dominance with a 300% lift in executive profile engagement.",
      downloads: "300% Eng Lift",
      rating: "4.9",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop",
    },
  ],
};

// 5. Technologies Data
export const socialTechnologiesData = {
  techTitle: "OUR SOCIAL-TECH STACK",
  technologies: [
    { name: "Meta/Insta", icon: "ReactNative" },
    { name: "TikTok/LinkedIn", icon: "ReactNative" },
    { name: "Attribution APIs", icon: "RestAPI" },
    { name: "Content Logic", icon: "Provider" },
    { name: "Real-time Alerts", icon: "Vite" },
  ],
  trustTitle: "PLATFORM PARTNERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Block
export const socialAboutData = [
  {
    title: "Social Media Marketing Services That Drive Real Business Growth",
    content: (
      <>
        Modern brands need more than likes and reach to stay competitive online. Effective <b className="text-text-primary font-semibold">social media marketing services</b> focus
        on creating meaningful audience interactions that support business growth and brand trust. Businesses that invest in structured social strategies often see stronger
        customer engagement and improved visibility across digital channels. At <b className="text-text-primary font-semibold">Tycho Technologies</b>, campaigns are built around
        audience behavior, platform intent, and measurable outcomes to help businesses scale with clarity instead of guesswork.
      </>
    ),
  },
  {
    title: "Social Media Marketing Agency for Performance-Focused Brands",
    content: (
      <>
        Choosing the right <b className="text-text-primary font-semibold">social media marketing agency</b> can significantly impact how businesses connect with their audience.
        Strong campaigns are built through platform-specific planning, audience segmentation, and content designed around customer behavior. Brands increasingly rely on{" "}
        <b className="text-text-primary font-semibold">instagram marketing services</b> to strengthen visibility and improve engagement where attention is highest. Tycho
        Technologies helps businesses create sustainable social systems that support long-term audience growth while adapting to changing platform algorithms and user expectations.
      </>
    ),
  },
  {
    title: "Facebook Advertising Agency for Smarter Customer Acquisition",
    content: (
      <>
        Paid social campaigns perform better when backed by audience insights and conversion-focused execution. A trusted{" "}
        <b className="text-text-primary font-semibold">facebook advertising agency</b> helps brands improve targeting accuracy, reduce wasted ad spend, and attract customers with
        higher purchase intent. Businesses often strengthen campaign performance by aligning paid efforts with a reliable{" "}
        <a href="https://tychotechnologies.com/email-automation-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          email automation services
        </a>{" "}
        strategy to improve retention and customer communication beyond the first interaction.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Social Media Marketing Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">social media marketing company in india</b> continues to grow as businesses seek cost-effective
        digital expansion strategies. Companies investing in <b className="text-text-primary font-semibold">social media management services india</b> often look for consistency,
        performance visibility, and scalable campaign execution. Businesses working with Tycho Technologies gain access to practical social frameworks designed around measurable
        growth. Many organizations also support stronger online visibility by partnering with a reliable{" "}
        <a href="https://tychotechnologies.com/seo-content-strategy-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          seo services company
        </a>{" "}
        to create a balanced digital growth strategy.
      </>
    ),
  },
];

// 7. FAQs (Preserved)
export const socialFaqData = [
  {
    q: "Why should I invest in social media marketing in India for my business?",
    a: "It helps businesses reach a larger audience, engage with customers, and build brand awareness cost-effectively across Facebook, Instagram, LinkedIn, and TikTok.",
  },
  {
    q: "How can YouTube marketing help my business?",
    a: "YouTube marketing promotes your brand through video tutorials and product demos, increasing visibility and driving significant traffic to your store.",
  },
];
